import {
  RECORD_LINKAGE,
} from '../constants';

export const showRecordLinkageView = (data) => data?.[RECORD_LINKAGE]?.length > 0;
